// extracted by mini-css-extract-plugin
export default {"center":"CarrierRemissionGuide_center__x7c+H","ionCard":"CarrierRemissionGuide_ionCard__g+Pkb","footer":"CarrierRemissionGuide_footer__BnLvs"};